import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { currentUser } from "system/InfegyUser";

export default function PageNotFound() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const activeUser = currentUser();

  if (!activeUser) {
    window.location.href = "/login";
  }

  return (
    <Stack
      sx={{
        gap: 2,
        alignItems: "center",
        p: 2,
        height: "100%",
        justifyContent: "center"
      }}>
      <img style={{ maxHeight: "100%", maxWidth: "100%" }} src="/img/404.png" alt="Resource not found" />
      <Typography variant="h3" sx={{
        textAlign: "center"
      }}>{i18n.t("dashboard.errors.not-found")}</Typography>
      <Button variant="outlined" onClick={() => navigate("/start")}>{i18n.t("dashboard.errors.return-to-homepage")}</Button>
    </Stack>
  );
}